import PropTypes from 'prop-types';
import useLocale from 'Hooks/useLocale';
import { cn } from 'Utils/cn';
import IconInvoiceType from 'Components/Atoms/IconInvoiceType/IconInvoiceType';
import { useTranslation } from 'react-i18next';
import InvoiceAmount from '../InvoiceAmount/InvoiceAmount';

export default function CardInvoice(props) {
    const { invoice, className } = props;

    const locale = useLocale();
    const { t } = useTranslation('invoices');

    if (!invoice) {
        return null;
    }

    const displayName = invoice.invoice_party_display_name || t('no-contact-name');

    return (
        <div
            className={cn(
                'relative group grid grid-cols-[32px_1fr_auto] items-center gap-3 text-gray-500 text-left rounded-lg transition-shadow sm:grid-cols-[32px_1.5fr_1fr_1fr_auto]',
                className,
            )}
        >
            <div>
                <IconInvoiceType invoice={invoice} />
            </div>
            <div className="overflow-hidden">
                <div className="text-sm font-semibold truncate" title={displayName}>
                    {invoice.invoice_party_display_name ? (
                        invoice.invoice_party_display_name
                    ) : (
                        <span className="opacity-50">{t('no-contact-name')}</span>
                    )}
                </div>
                <div className="truncate text-xs">{invoice.identifier}</div>
            </div>
            <div className="text-right sm:text-left">
                <div className="uppercase font-semibold text-2xs tracking-widest">{t('total')}</div>
                <div className="flex justify-start">
                    <InvoiceAmount invoice={invoice} className="text-xs" showAccountingDelivered={false} />
                </div>
            </div>

            <div className="sm:hidden" />

            <div>
                <div className="uppercase font-semibold text-2xs tracking-widest">{t('issued')}</div>
                <div className="text-xs">
                    {invoice.date_emission ? invoice.date_emission.toLocaleDateString(locale) : '-'}
                </div>
            </div>
            <div className="text-right sm:text-left">
                <div className="uppercase font-semibold text-2xs tracking-widest">{t('overdue')}</div>
                <div className="text-xs">
                    {invoice.date_expiration ? invoice.date_expiration.toLocaleDateString(locale) : '-'}
                </div>
            </div>
        </div>
    );
}

CardInvoice.propTypes = {
    invoice: PropTypes.object.isRequired,
    className: PropTypes.string,
};
